import React, { Component } from "react";
//import {API_TOKEN_NAME} from '../../constants';
//import { scAxios } from '../../';
//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';
//import { Outlet,Link } from "react-router-dom";
class Footer extends Component {
  render() {
    return <footer className="footer">© 2024 United Hospital Limited</footer>;
  }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/component/admin/Footer.js